import React, { Component } from "react";
import Modal from "react-responsive-modal";
import FirstCase from "../component/FirstCase";
import "../assets/css/RoutineScreen.css";
import { connect } from "react-redux";
import {
  setCases,
  setCurrentCase,
  setCurrentSelection
} from "../actions/cases";
import privatew from "../assets/image/private-w.png";
import privateb from "../assets/image/private-b.png";
import companyw from "../assets/image/company-w.png";
import companyb from "../assets/image/company-b.png";

//import "bootstrap/dist/css/bootstrap.min.css";
//import SecondCase from "../component/SecondCase";
class RoutineScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      kind: -1,
      case: -1
    };
  }

  renderModal() {
    return (
      <Modal
        open={this.state.modal}
        onClose={() => this.setState({ modal: false })}
        center
      >
        <h2>This is a modal</h2>
        <button>Yeah</button>
      </Modal>
    );
  }

  isKindActive(id) {
    return id === this.state.kind ? " active" : " ";
  }

  switchKind(id) {
    this.setState({ kind: id, case: -1 });
  }

  isCaseActive(id) {
    return id === this.state.case ? " active" : " ";
  }

  switchCase(id) {
    this.setState({ case: id });
  }

  deleteCurrentCase() {
    this.props.cases[this.state.kind].splice(this.state.case, 1);
    this.setState({ case: -1 });
    this.forceUpdate();
  }

  renderCase(item, index) {
    //Fälligkeit
    var dateFormat = require("dateformat");
    var eindat = new Date(item.sumf.value);
    var raweindat = eindat.getTime() / (1000 * 3600 * 24);
    var roueindat = Math.round(raweindat);
    var rawfalldat = roueindat + 21;
    var falldat = rawfalldat * 1000 * 3600 * 24;
    var falldatum = dateFormat(falldat, "dd.mm.yyyy");

    let icon = companyw;
    let resp = "";
    if (item.kind) {
      if (index === this.state.case) {
        icon = companyb;
      }
    } else {
      if (index === this.state.case) {
        icon = privateb;
      } else {
        icon = privatew;
      }
    }

    if (item.kind) resp = item.contact;

    return (
      <div
        key={index}
        className={"case" + this.isCaseActive(index)}
        onClick={() => this.switchCase(index)}
      >
        {/* {this.state.kind === 2 ? null : null}
         <img src={icon} className="privateCompanyIndicator" alt="kiim" />
        <p>
          {item.name.value}
          <br />
          {resp}
        </p>
        <div
          className={"routineScreenVerticalLine" + this.isCaseActive(index)}
        ></div>
        <p>
          Fällig am
          <br /> {String(falldatum)}
        </p>
         <div
          className={"routineScreenVerticalLine" + this.isCaseActive(index)}
        ></div>
       <p>
          Rechnungsbetrag
          <br />
          {displayCurrency(
            item.sumg.value -
              this.props.case.sumg.value * (item.stats.zinsen.perc / 100),
            "EUR",
            "de-DE"
          )}
        </p>
        <p>›</p>*/}
      </div>
    );
  }

  renderPreview() {
    if (this.state.case >= 0) {
      let currentCase = this.props.cases[this.state.kind][this.state.case];
      if (this.state.kind >= 0) {
        return (
          <FirstCase
            case={'currentCase'}
            kind={this.state.kind}
            delete={() => this.deleteCurrentCase()}
          />
        );
      } /* else {
        this.props.setCurrentCase(currentCase);
        this.props.setCurrentSelection({
          kind: this.state.kind,
          case: this.state.case
        });
        // console.log("current case:", currentCase);
        return (
          <SecondCase
            case={currentCase}
            delete={() => this.deleteCurrentCase()}
            switchScreen={this.props.switchScreen}
          />
        );
      }
    } else {
      return null;*/
    }
  }

  render() {
    let cases = [];
    if (this.state.kind >= 0) cases = this.props.cases[this.state.kind];

    return (
      <div className="routineScreen">
        <div className="routineContainer">
          <div className="routineTable">
            <div className="kinds">
              <div
                className={"kind critical" + this.isKindActive(0)}
                onClick={() => this.switchKind(0)}
              >
                <p>Überfällige Rechnungen</p>
                <div className="routineScreenVerticalLine"></div>
                <p>{this.props.cases[0].length}</p>
                <p>›</p>
              </div>

              <div
                className={"kind again" + this.isKindActive(1)}
                onClick={() => this.switchKind(1)}
              >
                <p>Wiedervorlage</p>
                <div className="routineScreenVerticalLine"></div>
                <p>{this.props.cases[1].length}</p>
                <p>›</p>
              </div>
              <div
                className={"kind new" + this.isKindActive(2)}
                onClick={() => this.switchKind(2)}
              >
                <p style={{ paddingLeft: 2, paddingRight: 2 }}>
                  Neue Rechnungen
                </p>
                <div className="routineScreenVerticalLine"></div>
                <p>{this.props.cases[2].length}</p>
                <p>›</p>
              </div>
              <div
                className={"kind new" + this.isKindActive(3)}
                onClick={() => this.switchKind(3)}
              >
                <p style={{ paddingLeft: 2, paddingRight: 2 }}>Fällig</p>
                <div className="routineScreenVerticalLine"></div>
                <p>{this.props.cases[3].length}</p>
                <p>›</p>
              </div>
              {/*<div
                className={"kind new" + this.isKindActive(4)}
                onClick={() => this.switchKind(4)}
              >
              } <p style={{ paddingLeft: 2, paddingRight: 2 }}>Unbearbeitet</p>
                <div className="routineScreenVerticalLine"></div>
                <p>{this.props.cases[4].length}</p>
                <p>›</p>
              </div>*/}
              <div
                className={"kind new" + this.isKindActive(5)}
                onClick={() => "/"}
              >
                <p style={{ paddingLeft: 2, paddingRight: 2 }}>Suche</p>
                <div className="routineScreenVerticalLine"></div>
                <p>›</p>
              </div>
            </div>
            <div className="cases">
              {/* <div className='case'>
                <p>Kaiser GmbH</p>
                <p>Belege <br/> 2</p>
                <p>Gesamtbetrag <br/> 14.000$</p>
                <p>›</p>
              </div>
              <div className='case active'>
                <p>Manufaktur Inc.</p>
                <p>Belege <br/> 5</p>
                <p>Gesamtbetrag <br/> 3.579$</p>
                <p>›</p>
              </div>
              <div className='case'>
                <p>Stadt Lyss</p>
                <p>Belege <br/> 7</p>
                <p>Gesamtbetrag <br/> 21.000$</p>
                <p>›</p>
              </div>
              <div className='case'>
                <p>Fleischer Dude</p>
                <p>Belege <br/> 5</p>
                <p>Gesamtbetrag <br/> 300$</p>
                <p>›</p>
              </div>
              <div className='case'>
                <p>Fleischer Dude</p>
                <p>Belege <br/> 5</p>
                <p>Gesamtbetrag <br/> 300$</p>
                <p>›</p>
              </div> */}
              {cases.map((item, index) => {
                return this.renderCase(item, index);
              })}
            </div>
            <div className="caseContainer">{this.renderPreview()}</div>
          </div>
        </div>
        {this.renderModal()}
      </div>
    );
  }
}
function displayCurrency(number, curr, locale) {
  if (locale === undefined) {
    locale = "en-US";
  }
  if (curr === undefined) {
    curr = "USD";
  }
  var formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: curr
  });
  return formatter.format(number);
}
/*function openDoc(a) {
  // window.open(PDF);
  // <Document file={this.state.file} onLoadSuccess={this.onDocumentLoadSuccess} noData={<h4>Please select a file</h4>}>
  //   <Page pageNumber={pageNumber} />
  // </Document>
  a.setState({ modal: true });
}*/

const mapStateToProps = state => {
  return {
    cases: state.cases
  };
};

const mapDispatchToProps = dispatch => ({
  setCases: cases => {
    dispatch(setCases(cases));
  },
  setCurrentCase: curCase => {
    dispatch(setCurrentCase(curCase));
  },
  setCurrentSelection: selection => {
    dispatch(setCurrentSelection(selection));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RoutineScreen);



// WEBPACK FOOTER //
// ./src/screens/RoutineScreen.js